import React from "react";
import { validateField } from "../components/Utilities";


export default class DataInput extends React.Component {
    onChange = (value) => {
        let { setValue, field, removeValidateData } = this.props;
        setValue && setValue(field, value);
        removeValidateData && removeValidateData(field);
    }
    onFocus = () => {
        this.props.onFocus && this.props.onFocus();
    }
    onBlur = () => {
        let { data, mandatoryFields, setValidateData, field, validate, onBlur } = this.props;
        if (validate || (mandatoryFields && mandatoryFields[field])) {
            let value = data && data[field];
            if (mandatoryFields && mandatoryFields[field] && !value) {
                setValidateData(field, `${mandatoryFields[field]} is mandatory`)
            } else if (validate) {
                let { type, message } = validate;
                if (!validateField({ type, value })) {
                    setValidateData(field, message)
                }
            }
        }
        onBlur && onBlur()
    }
    render() {
        let { data, field, children, className = "", editable, val, validateData, autoFocus } = this.props;
        let value = data && (data[field] || "");
        let error = validateData && validateData[field];

        return (
            <div className={className}>
                {React.cloneElement(children, {
                    key: field,
                    value: val || value,
                    onChange: this.onChange,
                    onFocus:this.onFocus,
                    onBlur: this.onBlur,
                    editable,
                    autoFocus
                })}
                {error && <div className="errorStyle">{error}</div>}
            </div>
        )
    }
}